import React, { useEffect, useState } from 'react'
import { View, Image, Svg, Text } from 'react-native'
import themes from '../../../theme'
import StyledText from '../../../StyledText'
import CalculateDate from '../customUtils/calculateDates/calculateDates'
import { avatarPlaceholder } from '../customUtils/Constants'
import { baseURLWSocket } from '../../config/config'
import { connectionWebSocket } from '../../utils/webSocketUtils'
import { getUser, openDB } from '../../db/indexDB'
import parseThousands from '../customUtils/parseThousands/parseThousands'
import { getLanguage } from '../appBar/context/LocalizationContext'
import styles from './HeaderPostsStyles'
import { HeaderPostTheme } from '../../../themeConstants'
import Shimmer from '../customUtils/Components/Shimmer'

const HeaderPosts = ({ avatar, publisher, labels, date, views, views_local, loadingInteractions = false }) => {
    const { languageFile } = getLanguage()

    // Convertir a número si no lo es
    const totalViews = parseInt(views, 10) || 0
    const localViews = parseInt(views_local, 10) || 0

    // Determinar qué valor numérico usar
    const viewsCount = totalViews > localViews ? totalViews : localViews

    // Formatear las vistas con texto
    const parseViews = `${parseThousands(viewsCount)} ${languageFile.views}`

    return (
        <View style={styles.headerPost}>
            <View style={styles.avatarModulePost}>
                {/* {avatar && avatar !== ''( */}
                <Image
                    style={styles.image}
                    //source={{ uri: avatar ? avatar : avatarPlaceholder }}
                    source={HeaderPostTheme.clientDefaultImage}
                />
                {/*})}*/}

                <View style={styles.nameAvatarNamePost}>
                    <StyledText fontSize='smallText' color='textPrimary' fontWeight='bold' numberOfLines={1} ellipsizeMode='tail'>
                        {publisher ? publisher : HeaderPostTheme.clientNameDefaultText}
                    </StyledText>

                    {labels && (
                        <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                            {labels.map((tag, index) => (
                                <StyledText fontSize='ultraSmallText' color='textSecondary' key={index} numberOfLines={1} ellipsizeMode='tail'>
                                    {tag.name + (index < labels.length - 1 ? ', ' : '')}
                                </StyledText>
                            ))}
                        </View>
                    )}
                </View>
            </View>
            <View style={styles.leftHeaderPostDetail}>
                {date && <StyledText style={styles.datePost}>{CalculateDate(date)}</StyledText>}
                {loadingInteractions ? (
                    <Shimmer style={{ width: 90, height: 12, marginTop: 4 }} borderRadius={6} />
                ) : viewsCount >= 0 ? (
                    <StyledText style={styles.viewsPost}>{parseViews}</StyledText>
                ) : null}
            </View>
        </View>
    )
}

export default HeaderPosts
